$(function(){
  /* Collection page */
  $(document).on('onClickSwatch', 'ul.tt-options-swatch li', function(){
    $(this).addClass('selected-var').siblings('li').removeClass('selected-var');
    
    var isAllowToAdd = ($(this).parents('.tt-option-block').find('.tt-options-swatch').length == $(this).parents('.tt-option-block').find('.tt-options-swatch li.selected-var').length);
    if(isAllowToAdd) {
      $(this).parents('.tt-description').find('.tt-btn-addtocart').removeClass('btn-disabled');
    }
    else {
      $(this).parents('.tt-description').find('.tt-btn-addtocart').addClass('btn-disabled');
    }
  });
  
  /* FAQ page */
  $('.faq-container h5').on('click', function(){
    $(this).parents('li').toggleClass('active');
    $(this).parents('li').find('.faq-ans').slideToggle();
  });
});